import http from '@/plugins/request'
export const getUserInfo = (params) => {
    return http.request({
        url: 'fch/pda/pub',
        method: 'get',
        params
    })
}
// pda激活
export const pdaActive = (active_code,data) => {
    return http.request({
        url: 'fch/pda/active/'+active_code,
        method: 'POST',
        data
    })
}

// 码库配置
export const getCodeConfig = (data) => {
  return http.request({
      url: 'fch/pda/get_code_config',
      method: 'POST',
      data
  })
}

// pda登录
export const pdaLogin = (data) => {
    return http.request({
        url: 'fch/pda/login',
        method: 'POST',
        data
    })
}

